export default "__VITE_ASSET__Ir45CpUT__"